import type { GuestSession } from "./types";

const messages = {
  en: {
    continue: "Continue",
    play: "Play",
    club: "Club",
    settings: "Settings",
    back: "Back",
    save: "Save",
    home: "Home",
    loading: "Loading KipsBall"
  },
  id: {
    continue: "Lanjutkan",
    play: "Main",
    club: "Klub",
    settings: "Pengaturan",
    back: "Kembali",
    save: "Simpan",
    home: "Beranda",
    loading: "Memuat KipsBall"
  }
} as const;

export type MessageKey = keyof (typeof messages)["en"];

export function deviceLocale(): GuestSession["locale"] {
  return navigator.language.toLowerCase().startsWith("id") ? "id" : "en";
}

export function translate(locale: GuestSession["locale"], key: MessageKey): string {
  return messages[locale]?.[key] ?? messages.en[key];
}

